









import ThgVehicleTable from "@/components/thg-vehicle/ThgVehicleTable.vue";
import MHeader from "@/components/utility/mmmint/MHeader.vue";
import TheLayoutPortal from "@/layouts/TheLayoutPortal.vue";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";

@Component({
  components: {
    ThgVehicleTable,
    TheLayoutPortal,
    MHeader
  }
})
export default class ThgVehicleView extends mixins(PartnerFallbackMixin) {
  async mounted() {
    this.trySetByRouteOrDefault();
  }
}
